import GET_ARTICLES from "../class/getArticles";
import Swiper from "swiper/bundle";

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];
const domReady = TPL => {
  new BLOCKS;
  instaAPI(); // 関数の実行
  getArticleToModal( $('.free-banner__wrap'), {content: 'service',post_id: 3});
};

const getArticleToModal = ( $modalBody, param ) => {
  
  const applyDom = article => $modalBody.html( article.body );

  fetch(`/assets/api/getArticles/?${ new URLSearchParams(param)}`)
    .then( res => res.json()).then( res => applyDom(...res) );
}

class BLOCKS {
  constructor() {
    this.mainvisual();
    this.topics();
  }
  
  mainvisual () {
    let Mv = document.querySelector('.mainvisual');
    window.addEventListener('load', function() {
      Mv.classList.add('loaded');
    });

    //メインスライダー
    const mvSlide = new Swiper('.mv_slide[data-plugin="mainSlider"]',{
      loop: true,
      speed: 3000,
      effect: 'fade',
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true, // クロスフェードを有効にする（フェードモードの場合 true 推奨）
      },
      autoplay:{
        delay: 6000,
        disableOnInteraction: false,
        waitForTransition: false
      },
    });
  }

  topics () {
    //TOPICS
    const getArticle = new GET_ARTICLES('.block-topics__list');
    getArticle.makeItem = (item,content) => `
    <li>
      <a href="${item.href}">
        <figure><img src="${item.thumb}" alt="${item.title}" loading="lazy"></figure>
        <p class="ttl${(item.is_new)? ' new': ''}"><span>${item.title}</span></p>
        <p class="info"><span class="date">${item.date}</span><span class="cate">${item.category.name}</span></p>
      </a>
    </li>`;
    // getArticle.makeItem = (item) => console.log(item);
    getArticle.render();
  }

}

// instaAPI
async function instaAPI() {
// 子要素<ul>を追加
// document.querySelector('#insta').insertAdjacentHTML('beforeend', '<ul></ul>');

const cards = 7; // insta投稿の表示件数を指定
const businessId = '17841453096846830';
const token = 'EAAS01E1yCZAYBO7Cv8BaLeIxLgE8xJnQmbubfPWpzwtGR3lvI9QzDvRM8rY1cCtvxjOSMMQKaIT32SGCAh8CfkkKSjqOwcQKs6AAOCjoEn5mKKb8KwCszh8reMgkWVnh6hBri7VRlQhWghc8PbtEWx9YEwcD05X1POOR1j9UujlqUwoPGQIYMUdZBx9QxLgPVTCjubXLui5gTUp7gpNf5R';
const response = await fetch(
  `https://graph.facebook.com/v19.0/${businessId}?fields=name,media.limit(${cards}){ caption,media_url,thumbnail_url,permalink,like_count,comments_count,media_type}&access_token=${token}`
);

if (response.status === 200) {
  const resObjects = await response.json();
  console.log(resObjects);
  //（挙動への影響は一切無いものの）オブジェクト{resObjects.media}内のプロパティ{paging}のせいで「instaItems[1]が無いというエラー」が出るので削除して以降の処理を進めていく
  delete resObjects.media.paging;

  Object.entries(resObjects.media).forEach((instaItems) => {
    // console.log(instaItems);
    instaItems[1].forEach((eachItem) => {
      if (eachItem.media_url !== null) {
        // 投稿が動画か否かを判定して{media}を変更
        if (eachItem.media_type === 'VIDEO') {
          eachItem.media = eachItem.thumbnail_url;
        } else {
          eachItem.media = eachItem.media_url;
        }

        document
          .querySelector('#insta')
          .insertAdjacentHTML(
            'beforeend',
            `<li class="instafeed__item"><a href="${eachItem.permalink}" target="_blank" rel="noopener"><img src="${eachItem.media}"></a></li>`
          );
      }
    });
  });
} else {
  document
    .querySelector('#insta')
    .insertAdjacentHTML(
      'beforeend',
      `<p style="text-align:center;width:100%;">読み込めませんでした</p>`
    );
}
}

export default function HOME () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
}